module.exports = __webpack_public_path__ + "static/img/Rose.4d5ac396.png";